import script from "./SessionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionList.vue?vue&type=script&setup=true&lang=js"

import "./SessionList.vue?vue&type=style&index=0&id=54804e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54804e5a"]])

export default __exports__